module.exports = __webpack_public_path__ + "static/media/draw-window-winning@2x.68f6065e.png";